import _ from 'underscore';

const Order = {
  'AddMoreHeadlines-not-met': 1,
  'AddMoreDescriptions-not-met': 2,
  'AddMoreHeadlines-half-met': 3,
  'AddMoreDescriptions-half-met': 4,
  'LongerHeadlines-not-met': 5,
  'LongerDescriptions-not-met': 6,
  'DistinctHeadlines-not-met': 7,
  'DistinctDescriptions-not-met': 8,
  'UnpinHeadlinePositions-not-met': 9,
  'UnpinDescriptionPositions-not-met': 10,
  'LongerHeadlines-half-met': 11,
  'LongerDescriptions-half-met': 12,
  'DistinctHeadlines-half-met': 13,
  'DistinctDescriptions-half-met': 14,
  'UnpinHeadlinePositions-half-met': 15,
  'UnpinDescriptionPositions-half-met': 16,
  'MoreCombinations-not-met': 17,
  'MoreCombinations-half-met': 18,
  'AddMoreHeadlines-met': 19,
  'AddMoreDescriptions-met': 20,
  'LongerHeadlines-met': 21,
  'LongerDescriptions-met': 22,
  'DistinctHeadlines-met': 23,
  'DistinctDescriptions-met': 24,
  'UnpinHeadlinePositions-met': 25,
  'UnpinDescriptionPositions-met': 26,
  'MoreCombinations-met': 27,
};

const SuggestionState = {
  Met: 'met',
  HalfMet: 'half-met',
  NotMet: 'not-met',
};

const StrengthScore = {
  Poor: 25,
  Average: 50,
  Good: 75,
  Excellent: 100,
};

export const maxHeadlineCount = 15;

export const maxDescriptionCount = 4;

export const ViewSuggestionType = {
  None: 'none',
  Headline: 'headline',
  Description: 'description',
};

export function getStrengthScore(strength) {
  return StrengthScore[strength] || 0;
}

export function generateSuggestion({
  i18n,
  assets,
  actionItem,
  strength,
}) {
  const suggestion = i18n.getString(`Ad_Strength_Suggestion_${actionItem}`);
  let state = 'not-met';
  let suggestionType = ViewSuggestionType.None;

  switch (actionItem) {
    case 'AddMoreHeadlines': {
      const headlineCount = assets.headlines.length;
      if (headlineCount < 5) {
        state = SuggestionState.NotMet;
      } else if (headlineCount >= maxHeadlineCount
        || (headlineCount > 8 && getStrengthScore(strength) >= StrengthScore.Good)) {
        state = SuggestionState.Met;
      } else {
        state = SuggestionState.HalfMet;
      }
      suggestionType = ViewSuggestionType.Headline;
      break;
    }
    case 'AddMoreDescriptions': {
      const descriptionCount = assets.descriptions.length;
      if (descriptionCount < 2) {
        state = SuggestionState.NotMet;
      } else if (descriptionCount >= maxDescriptionCount
        || (descriptionCount > 3 && getStrengthScore(strength) >= StrengthScore.Good)) {
        state = SuggestionState.Met;
      } else {
        state = SuggestionState.HalfMet;
      }
      suggestionType = ViewSuggestionType.Description;
      break;
    }
    case 'DistinctHeadlines': {
      state = _.uniq(assets.headlines).length === assets.headlines.length
        ? SuggestionState.HalfMet
        : SuggestionState.NotMet;
      suggestionType = ViewSuggestionType.Headline;
      break;
    }
    case 'DistinctDescriptions':
      state = _.uniq(assets.descriptions).length === assets.descriptions.length
        ? SuggestionState.HalfMet
        : SuggestionState.NotMet;
      suggestionType = ViewSuggestionType.Description;
      break;
    case 'LongerHeadlines':
      state = (_.size(assets.headlines) === 0
        || _.any(assets.headlines, headline => _.size(headline) < 10))
        ? SuggestionState.NotMet
        : SuggestionState.HalfMet;
      suggestionType = ViewSuggestionType.Headline;
      break;
    case 'LongerDescriptions':
      state = (_.size(assets.descriptions) === 0
        || _.any(assets.descriptions, description => _.size(description) < 10))
        ? SuggestionState.NotMet
        : SuggestionState.HalfMet;
      suggestionType = ViewSuggestionType.Description;
      break;
    case 'UnpinHeadlinePositions': {
      const pinCount = assets.headlinePins.length;
      if (pinCount > 0) {
        state = pinCount === assets.headlines.length
          ? SuggestionState.NotMet
          : SuggestionState.HalfMet;
      } else {
        state = SuggestionState.Met;
      }
      suggestionType = ViewSuggestionType.None;
      break;
    }
    case 'UnpinDescriptionPositions': {
      const pinCount = assets.descriptionPins.length;
      if (pinCount > 0) {
        state = pinCount === assets.descriptions.length
          ? SuggestionState.NotMet
          : SuggestionState.HalfMet;
      } else {
        state = SuggestionState.Met;
      }
      suggestionType = ViewSuggestionType.None;
      break;
    }
    case 'MoreCombinations':
      if (assets.headlines.length < 5 || assets.descriptions.length < 3) {
        state = SuggestionState.NotMet;
      } else {
        state = SuggestionState.HalfMet;
      }
      if (assets.headlines.length < 10) {
        suggestionType = ViewSuggestionType.Headline;
      } else if (assets.descriptions.length < maxDescriptionCount) {
        suggestionType = ViewSuggestionType.Description;
      } else {
        suggestionType = ViewSuggestionType.None;
      }
      break;
    default:
      break;
  }

  return {
    action: actionItem,
    state,
    suggestion,
    suggestionType,
  };
}

export function sortSuggestions(suggestions) {
  return _.sortBy(suggestions, suggestion => Order[`${suggestion.action}-${suggestion.state}`] || 100);
}
